let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dZ3IW")).then(() => parcelRequire('1NtAt'));